module.exports = __webpack_public_path__ + "img/th.9044e545.svg";